import React, { useState } from "react";
import { useCheckout } from "../../providers/CheckoutProvider";
import UpsaleDialogCatalogue from "./UpsaleDialogCatalogue";
import UpsaleDialogDigitalFiles from "./UpsaleDialogDigitalFiles";

const UpsaleWizard = () => {
  const { upsaleList } = useCheckout();
  const [currentStep, setCurrentStep] = useState(0);

  const handleNextStep = () => {
    setCurrentStep((currentStep) => currentStep + 1);
  };

  console.log("Current step", currentStep, upsaleList);

  if (!upsaleList || currentStep === upsaleList.length) {
    return null;
  }

  switch (upsaleList[currentStep].type) {
    case "CATALOGUE":
      return (
        <UpsaleDialogCatalogue
          handleNextStep={handleNextStep}
          {...upsaleList[currentStep]}
        />
      );
    case "DIGITAL_FILES":
      return (
        <UpsaleDialogDigitalFiles
          handleNextStep={handleNextStep}
          {...upsaleList[currentStep]}
        />
      );
  }
  return null;
};

export default UpsaleWizard;
